import BaseView from "./_BaseView";
import Table from "../components/Table";
import Api from "../Api";
import Confirm from "../components/Confirm";

export default class TrialTermsView extends BaseView {
    constructor() {
        super();
        this.formSelector = '#trialTermForm';
        this.formUrl = '/api/trialterms';
        this.formTpl = 'trial-term-form';
        this.formTitle = Lang.trialterms;
        this.defaultObject = {
            title: '',
            days: '',
            guides: '',

        };
        this.formCallback = function () {
            this.table.reload();
        };
    }

    init() {
        super.init();

        if ($('#trial-terms').length > 0) {
            this.table = new Table('trial-terms', '/api/trialterms/table', [
                {data: 'title'},
                {data: 'days'},
                {data: 'guides'},
                {data: 'welcome_guide'},
                {data: 'midpoint_guide'},
                {data: 'end_guide'},
                {data: 'pardot_id'},
                {data: 'iframe'},
                {data: 'landing'},
                {data: 'tools', orderable: false},
            ]);
        }
    }

    renderForm(obj) {
        const self = this;
        let method, url;
        if (!obj) {
            obj = this.defaultObject;
            method = 'post';
            url = this.formUrl;
        } else {
            method = 'patch';
            url = `${this.formUrl}/${obj._id}`;
        }

        // app should be set in the template
        // TODO: account for enterprise type in template
        Api.send('/api/guides').done(function (g) {
            Api.getTpl(self.formTpl).done(function (r) {
                const tpl = _.template(r);

                Confirm({
                    ok: Lang.save,
                    title: self.formTitle,
                    msg: tpl({item: obj, guides: g}),
                    classes: self.modalClasses,
                    onValidate: function () {
                        return self.validateForm();
                    },
                    onConfirm: function () {
                        const data = self.getFormData();
                        Api.send(url, data, method).done(function () {
                            self.formCallback();
                        });

                    }
                });
            });
        });
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const trialTable = $('#trial-terms');

        $('.add-trial-term').on('click', function () {
            self.renderForm();
            return false;
        });

        trialTable.on('click', '.edit', function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/trialterms/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });

        trialTable.on("click", ".delete:not(.disabled)", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(1)').text();

            Confirm({
                ok: Lang.delete,
                title: name,
                msg: Lang.delsure,
                onConfirm: function () {
                    Api.send(`/api/trialterms/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });

            return false;
        });
    }
}
